import React from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
export function EditUser() {
  return <div className="space-y-6" data-id="element-292">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-293">Edit User</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-294">
        {/* Left Column: Profile Fields */}
        <Card data-id="element-295">
          <CardHeader data-id="element-296">
            <CardTitle data-id="element-297">Profile Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-298">
            <Input label="Title" defaultValue="Mr." data-id="element-299" />
            <Input label="First Name" defaultValue="John" data-id="element-300" />
            <Input label="Last Name" defaultValue="Doe" data-id="element-301" />
            <Input label="Company" defaultValue="Acme Landscaping" data-id="element-302" />
            <Input label="Address 1" defaultValue="123 Desert Way" data-id="element-303" />
            <Input label="Address 2" data-id="element-304" />
            <Input label="City" defaultValue="Phoenix" data-id="element-305" />
            <Select label="State/Province *" options={[{
            value: 'AZ',
            label: 'Arizona'
          }, {
            value: 'CA',
            label: 'California'
          }, {
            value: 'NV',
            label: 'Nevada'
          }]} data-id="element-306" />
            <Input label="Zip" defaultValue="85001" data-id="element-307" />
            <Input label="Phone" defaultValue="555-0123" data-id="element-308" />
            <Input label="Email" helperText="Email (Leave blank to keep existing email (administration@desertsageseminars.com))" data-id="element-309" />
            <Input label="Fax" data-id="element-310" />
            <Input label="How Did You Hear About Us" defaultValue="Google Search" data-id="element-311" />
            <Input label="Facebook" data-id="element-312" />
            <Input label="Username" helperText="Username (Leave blank to keep existing username (admin))" data-id="element-313" />
            <Input type="password" label="Password" helperText="Password (Leave blank to keep existing password)" data-id="element-314" />

            <div className="py-2" data-id="element-315">
              <a href="#" className="text-blue-600 hover:underline text-sm" data-id="element-316">
                Click here to obtain your license expiration date from ADRE
              </a>
            </div>

            <Input label="Available Courses" defaultValue="0" data-id="element-317" />

            <div className="pt-4" data-id="element-318">
              <Button data-id="element-319">Update</Button>
            </div>
          </CardContent>
        </Card>

        {/* Right Column: Course Assignments */}
        <div className="space-y-6" data-id="element-320">
          <Card data-id="element-321">
            <CardHeader data-id="element-322">
              <CardTitle data-id="element-323">Assign Course</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-324">
              <Select label="Course" options={[{
              value: '1',
              label: 'Desert Ecology Basics'
            }, {
              value: '2',
              label: 'Advanced Water Conservation'
            }]} data-id="element-325" />
              <Select label="Statuses" options={[{
              value: 'completed',
              label: 'Course Completed'
            }, {
              value: 'in_progress',
              label: 'Course in Progress'
            }, {
              value: 'emailed',
              label: 'Certificate Emailed'
            }, {
              value: 'enrolled',
              label: 'Course Enrolled'
            }, {
              value: 'section_progress',
              label: 'Section in Progress'
            }]} data-id="element-326" />
              <Button className="w-full gap-2" data-id="element-327">
                <Plus className="h-4 w-4" data-id="element-328" />
                Add
              </Button>
            </CardContent>
          </Card>

          <Card data-id="element-329">
            <CardHeader data-id="element-330">
              <CardTitle data-id="element-331">Enrolled Courses</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto" data-id="element-332">
              <table className="w-full text-sm text-left" data-id="element-333">
                <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-334">
                  <tr data-id="element-335">
                    <th className="px-4 py-3" data-id="element-336">Course Name</th>
                    <th className="px-4 py-3" data-id="element-337">Credit Type</th>
                    <th className="px-4 py-3" data-id="element-338">Created</th>
                    <th className="px-4 py-3" data-id="element-339">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-340">
                  <tr className="hover:bg-slate-50" data-id="element-341">
                    <td className="px-4 py-3" data-id="element-342">
                      Desert Ecology Basics{' '}
                      <span className="text-slate-500" data-id="element-343">(Course enrolled)</span>
                    </td>
                    <td className="px-4 py-3" data-id="element-344">General</td>
                    <td className="px-4 py-3" data-id="element-345">2023-10-15</td>
                    <td className="px-4 py-3" data-id="element-346">
                      <div className="flex items-center gap-2" data-id="element-347">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-348">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-349" />
                        </Button>
                        <Button variant="ghost" size="icon" title="Delete" data-id="element-350">
                          <Trash2 className="h-4 w-4 text-red-600" data-id="element-351" />
                        </Button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}